import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar, Phone } from 'lucide-react';
import { Button } from '../ui/button';

export const CTASection = ({
  title,
  subtitle,
  buttonText = 'Jetzt Termin buchen',
  buttonLink = '/termin',
  secondaryButtonText,
  secondaryButtonLink
}) => {
  return (
    <section className="cta-section">
      <div className="container mx-auto px-4 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-2xl mx-auto"
        >
          <h2 className="text-2xl md:text-3xl font-semibold text-white mb-4">
            {title}
          </h2>

          {subtitle && (
            <p className="text-white/80 mb-8 text-lg">
              {subtitle}
            </p>
          )}

          <div className="flex flex-wrap justify-center gap-4">
            <Link to={buttonLink}>
              <Button
                size="lg"
                className="btn-pill bg-[#ddc57b] hover:bg-[#c9b36d] text-[#0b382a] font-semibold px-8 transition-colors duration-200"
              >
                <Calendar className="w-5 h-5 mr-2" />
                {buttonText}
              </Button>
            </Link>

            {secondaryButtonText && secondaryButtonLink && (
              <Link to={secondaryButtonLink}>
                <Button
                  size="lg"
                  variant="outline"
                  className="btn-pill !border-white/80 !bg-transparent !text-white hover:!border-[#edd68d] hover:!bg-[#edd68d] hover:!text-[#032925] font-semibold px-8 shadow-none transition-colors duration-200 [&_svg]:!text-current"
                >
                  <Phone className="w-5 h-5 mr-2" />
                  {secondaryButtonText}
                </Button>
              </Link>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;